
import { TiptapEditor } from './../../../framework/ui/components/tiptap/tiptap-editor.cmp';
import { switchMap, map, tap } from 'rxjs/operators';
import {  ComponentRef, ComponentFactoryResolver, Injector } from '@angular/core';
import { merge, Observable, of, fromEvent } from 'rxjs';
import { DiagramLocatorLocator } from '../../diagram/locator/diagram-locator-locator';
import { CommandService } from 'flux-core';
import { KeyCode } from 'flux-definition/src';
import { DiagramCommandEvent } from 'apps/nucleus/src/editor/diagram/command/diagram-command-event';
import { DynamicComponent } from 'flux-core/src/ui';

export abstract class AbstractTiptapDocumentsManager extends DynamicComponent {

    abstract getDocuments();
    abstract createTiptap( diagramId: string );
    abstract cleanUpTextNodes( diagramId: string, shapeIds: string[] );
    abstract removeShapeTextNodes( diagramId: string, shapeId: string );

    constructor(
        protected componentFactoryResolver: ComponentFactoryResolver,
        protected injector: Injector,
        protected ll: DiagramLocatorLocator,
        protected commandSvc: CommandService,
    ) {
        super( componentFactoryResolver, injector );
    }

    protected getEditor( diagramId ): Observable<ComponentRef<TiptapEditor>> {
        const cmpRef = this.getDocuments()[ diagramId ];
        if ( !cmpRef ) {
            return this.createTiptap( diagramId ).pipe(
                tap( cr => this.getDocuments()[ diagramId ] = cr ),
            );
        }
        return of( cmpRef );
    }

    protected manageShapeDeletes() {
        return this.ll.forCurrentObserver( false ).pipe(
            switchMap( l => merge(
                l.getDiagramOnce().pipe( tap( d =>  {
                    this.cleanUpTextNodes( d.id,  Object.keys( d.shapes ));
                })),
                l.getDiagramChanges().pipe(
                    map( c =>  {
                        if ( c.source !== 'init' && c.split && c.split.shapes ) {
                            Object.keys( c.split.shapes )
                                .map( key => {
                                    const m = c.split.shapes[ key ];
                                    if (  m.$unset as any === true ) {
                                        this.removeShapeTextNodes( c.model.id, key );
                                    }
                                });
                        }
                    }),
                ),
            )),
        );
    }

    /**
     * Update text on Escape
     * @param tipTapEditorCmp
     * @protected
     */
    protected escapeSub( tipTapEditorCmp ) {
        return fromEvent( tipTapEditorCmp.editorElement.nativeElement, 'keydown' )
            .subscribe(( e: KeyboardEvent ) => {
                if ( e.keyCode === KeyCode.Escape ) {
                    tipTapEditorCmp.change.next( tipTapEditorCmp.getChildEditorHTML());
                }
            });
    }

    /**
     * Dispatches the changeShapeDataItems command to update data items
     */
     protected onChildNodeviewChange( diagramId: string, change: { shapeId: string, html: any }) {
        const shapeId = change?.shapeId;
        if ( shapeId ) {
            this.commandSvc.dispatch( DiagramCommandEvent.changeShapeDataItems, diagramId, {
                [shapeId]: {
                    description: {
                        value: change.html,
                    },
                },
            });
        }
    }


}